import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ui/toaster';
import { AuthProvider } from './providers/AuthProvider';
import LoginPage from './pages/LoginPage';
import ProfilePage from './pages/ProfilePage';
import ErrorPage from './pages/ErrorPage';
import DemoProfilePage from './pages/DemoProfilePage';
import MyStatsPage from './pages/MyStatsPage';
import MyMatchesPage from './pages/MyMatchesPage';
import LeaderboardPage from './pages/LeaderboardPage';
import './App.css';

function App() {
  return (
    <div className="App min-h-screen bg-gradient-to-br from-cyan-100 via-blue-50 to-white font-prompt">
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/" element={<LoginPage />} />
            <Route path="/me" element={<ProfilePage />} />
            <Route path="/error" element={<ErrorPage />} />
            <Route path="/demo" element={<DemoProfilePage />} />
            <Route path="/mystats" element={<MyStatsPage />} />
            <Route path="/mymatches" element={<MyMatchesPage />} />
            <Route path="/leaderboard" element={<LeaderboardPage />} />
          </Routes>
          <Toaster />
        </Router>
      </AuthProvider>
    </div>
  );
}

export default App;